import React, { useEffect, useState, useRef } from "react";
// import AddIcon from "../Assets/images/plus.png";
import deleteIcon from "../Assets/images/delete.png";
import "../css/chatbot.css";
// import axios from "axios";
// import helper from '../axios';
import { apiCall } from '../services/authServieces';

import DocIcon from '../Assets/images/document-icon.png'
import ImageIcon from '../Assets/images/image-icon.png'
import AudioIcon from '../Assets/images/music.png'
import VideoIcon from '../Assets/images/video-icon.png'
import { ClipLoader } from "react-spinners";
import EditIcon from '../Assets/images/edit.png'
import DeleteIcon from '../Assets/images/deletered.png'

// const base_url = helper.api_url;

const Chatboat = () => {
  const [loading, setLoading] = useState(false);
  const [options, setOptions] = useState([]);
  // const [stage, setStage] = useState("");
  const [title, setTitle] = useState("");
  const [question, setQuestion] = useState("");
  const [qType, setQType] = useState("TEXT");
  const [answer, setAnswer] = useState("");
  const [tableData, setTableData] = useState([]);
  const [errors, setErrors] = useState({ question: "", answer: "" });
  const [getBotId, SetBotId] = useState('BotIdexample');
  const [getBotname, setBotname] = useState('Botnameexample');
  const [getcreateDate, setCreateddate] = useState('Botdateexample');
  const [dataUpdated, setDataUpdated] = useState(false);
  const [selectedOption, setSelectedOption] = useState("Wel_101");
  const [root, SetRoot] = useState('');
  const [fileOptions, setFileOptions] = useState(null);
  const [fileData, setFileData] = useState("");
  const [ansFrom, setansFrom] = useState("");
  const [selectedQuestion, setSelectedQuestion] = useState(null);
  const [editModalOpen, setEditModalOpen] = useState(false);
  const [newAnswer, setNewAnswer] = useState('');

  const [isActive, setIsActive] = useState(false);
  const [inputCount, setInputCount] = useState(1);
  // Add a new state for tracking input values
  const [inputValues, setInputValues] = useState([]);


  const [showEmojiPicker, setShowEmojiPicker] = useState(false);
  const textareaRef = useRef(null);

  // new bot changes

  const [userCheckBox, setUserCheckBox] = useState(false);
  const [userInputAns, setUserInputAns] = useState("");
  // These state variables need to be defined in your component:
  const [isButtonUrlActive, setIsButtonUrlActive] = useState(false);
  const [buttonUrlInputCount, setButtonUrlInputCount] = useState(1);
  const [buttonUrlInputValues, setButtonUrlInputValues] = useState({});

  const handleCheckBoxChange = (e) => {

    let checkeddata = e.target.checked;

    checkeddata ? setUserCheckBox(e.target.checked) : setUserCheckBox(e.target.checked), setUserInputAns('');

    // if(checkeddata){

    //   setUserCheckBox(e.target.checked); 

    // }else{

    //   setUserCheckBox(e.target.checked); 

    //   setUserInputAns('');

    // }
  };




  const fetchData = async (parent_id) => {
    if (!parent_id) return;

    const storedBotData = localStorage.getItem('botData');
    if (storedBotData) {
      const { botId, botName, created_date } = JSON.parse(storedBotData);
      const body = {
        parent_id,
        bot_id: botId
      };
      setLoading(true);
      try {
        const response = await apiCall({ endpoint: 'api/get-bot-que-ans', method: 'post', payload: body });
        setTableData(response.data || []);
        console.log('response.data: 111111111111111', response.data);


        const body1 = {
          question_id: parent_id
        };
        const response1 = await apiCall({ endpoint: 'api/get-title-root-path', method: 'post', payload: body1 });
        SetRoot(response1.data[0]?.hierarchy || '');

        SetBotId(botId);
        setBotname(botName);
        setCreateddate(created_date);
      } catch (error) {
        console.error('Error fetching data:', error);
      } finally {
        setLoading(false);
      }
    }
  };

  const fetchDropDownData = async () => {
    const storedBotData = localStorage.getItem('botData');
    if (storedBotData) {
      const { botId, botName, created_date, userId, businessNo, adminId } = JSON.parse(storedBotData);
      const body = {
        bot_id: botId,
        admin_id: adminId,
        created_by: userId,
        business_no: businessNo
      };
      setLoading(true);
      try {
        const response = await apiCall({ endpoint: 'api/get-bot-que', method: 'post', payload: body });
        setOptions(response.data || []);

        SetBotId(botId);
        setBotname(botName);
        setCreateddate(created_date);
      } catch (error) {
        console.error('Error fetching dropdown data:', error);
      } finally {
        setLoading(false);
      }
    }
  };

  useEffect(() => {
    fetchDropDownData();
  }, []);

  useEffect(() => {
    if (selectedOption) {
      fetchData(selectedOption);
    }
  }, [selectedOption]);

  useEffect(() => {

    setFileOptions(qType === 'DOCUMENT' || qType === 'IMAGE' || qType === 'image');
  }, [qType]);


  const validateInputs = () => {
    let valid = true;
    const newErrors = { question: "", answer: "" };

    if (!question.trim()) {
      newErrors.question = "Question cannot be empty.";
      valid = false;
    }

    if (!answer.trim()) {
      newErrors.answer = "Answer cannot be empty.";
      valid = false;
    }
    if (!ansFrom.trim()) {
      newErrors.ansFrom = "Answer from cannot be empty.";
      valid = false;

    }

    setErrors(newErrors);
    return valid;
  };






  // Function to handle input changes
  const handleInputChange = (index, value) => {
    // Create a copy of the current input values array
    const newInputValues = [...inputValues];
    // Update the value at the specified index
    newInputValues[index] = value;
    // Update the state
    setInputValues(newInputValues);

    const newValues = [...inputValues];
    newValues[index] = value;
    setInputValues(newValues);

  };

  const handleSave = async () => {
    if (validateInputs()) {
      const storedBotData = localStorage.getItem('botData');
      if (!storedBotData) return;

      // Validate dynamic inputs for BUTTON type
      const dynamicInputsValid = qType !== 'BUTTON' || (inputValues.length === inputCount &&
        inputValues.every(value => value && value.trim() !== ''));

      // Validate button_url inputs
      const buttonUrlInputsValid = qType !== 'button_url' || (
        Object.keys(buttonUrlInputValues).length > 0 &&
        Array(buttonUrlInputCount).fill().every((_, i) =>
          buttonUrlInputValues[`text_${i}`]?.trim() !== '' &&
          buttonUrlInputValues[`url_${i}`]?.trim() !== ''
        )
      );

      // Add input validation error if needed for BUTTON
      if (qType === 'BUTTON' && !dynamicInputsValid) {
        setErrors(prev => ({
          ...prev,
          dynamicInputs: "All input fields must be filled"
        }));
        return;
      }

      // Add input validation error if needed for button_url
      if (qType === 'button_url' && !buttonUrlInputsValid) {
        setErrors(prev => ({
          ...prev,
          buttonUrlInputs: "All button text and URL fields must be filled"
        }));
        return;
      }

      const { userId, businessNo, adminId } = JSON.parse(storedBotData);

      const newData = {
        admin_id: adminId,
        created_by: userId,
        business_no: businessNo,
        title,
        question,
        msg_type: qType,
        answer,
        bot_id: getBotId,
        parent_id: selectedOption,
        ansfrom: ansFrom,
        userCheckBox: userCheckBox,
        userInputAns: userInputAns
      };

      // Add the dynamic input values to the payload if qType is BUTTON
      if (qType === 'BUTTON') {
        newData.dynamicInputs = inputValues.slice(0, inputCount);
      }

      // Add the button_url values to the payload if qType is button_url
      if (qType === 'button_url') {
        // Format the button_url data as an array of {text, url} objects
        const buttonUrlData = [];
        for (let i = 0; i < buttonUrlInputCount; i++) {
          if (buttonUrlInputValues[`text_${i}`] && buttonUrlInputValues[`url_${i}`]) {
            buttonUrlData.push({
              text: buttonUrlInputValues[`text_${i}`],
              url: buttonUrlInputValues[`url_${i}`]
            });
          }
        }
        newData.buttonUrls = buttonUrlData;
      }

      const formData = new FormData();
      formData.append('file', fileData);
      formData.append('data', JSON.stringify(newData));
      setLoading(true);
      try {
        const response = await apiCall({ endpoint: 'api/save-bot-que-ans', method: 'post', payload: formData });

        if (response.status === 200) {
          await fetchData(selectedOption);
          await fetchDropDownData();

          setQuestion("");
          setQType("TEXT");
          setAnswer("");
          setUserCheckBox(false);
          setUserInputAns("");
          setTitle('');
          setInputValues("");
          setInputCount(1);
          setIsActive(true);

          // Reset button_url related states
          setIsButtonUrlActive(false);
          setButtonUrlInputCount(1);
          setButtonUrlInputValues({});

          setErrors({ question: "", answer: "" });

          console.log('Saved to DB:', response.data);
        } else {
          alert(response.message || 'Failed to save');
        }
      } catch (err) {
        console.error('Error:', err);
      } finally {
        setLoading(false);
      }
    }
  };


  const handleUserFilechange = async (e) => {
    try {
      let data = e.target.files[0];

      if (data) {
        // Check if the file size is less than 2 MB (2 * 1024 * 1024 bytes)
        if (data.size < 2 * 1024 * 1024) {

          setFileData(data);

        } else {
          alert("File size should be less than 2 MB.");
          // Optionally, you can clear the file input
          e.target.value = null;
        }
      }
    } catch (err) {
      console.log(err);
    }
  };


  const handleDeleteRow = async (id) => {
    setLoading(true);
    try {

      const formData = new FormData();
      formData.append('id', JSON.stringify(id))

      const response = await apiCall({ endpoint: 'api/delete-bot-que-ans', method: 'post', payload: formData });

      if (response.status === 200) {
        alert(response.message);
        setTableData((prevData) => prevData.filter((row) => row.id !== id));
      } else {
        console.error('Failed to Update:', response.data.error);
      }
    } catch (error) {
      console.error('Error Updated row:', error);
    } finally {
      setLoading(false);
    }
  };


  const handleUpdateAnswer = async () => {
    setLoading(true);
    try {

      const payload = {
        id: selectedQuestion.id,
        answer: newAnswer
      };

      const response = await apiCall({ endpoint: 'api/update-bot-answer', method: 'post', payload });

      if (response.success) {
        alert("Answer updated successfully!");
        setEditModalOpen(false); // close modal
        setSelectedQuestion(null); // clear old data
        setNewAnswer(""); // clear input

        // ✅ Refresh table data
        // window.location.reload(); // ✅ page reload

        fetchData(selectedOption)


        // OR force reload the page
        // window.location.reload();
      } else {
        alert("Failed to update answer");
      }
    } catch (error) {
      console.error("Error updating answer:", error);
    } finally {
      setLoading(false);
    }
  };




  const handleEditClick = async (id) => {

    try {

      const response = await apiCall({ endpoint: `api/get-bot-que-by-id`, method: 'post', payload: { id: id } });
      console.log('response: ', response.data[0]);

      if (response.success) {
        setSelectedQuestion(response.data[0]); // Set data for modal


        setEditModalOpen(true); // Open the modal

      } else {
        alert("Failed to fetch question data");
      }
    } catch (error) {
      console.error("Error fetching question:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (editModalOpen && selectedQuestion) {
      console.log("Modal open with data: ", selectedQuestion);
    }
  }, [editModalOpen, selectedQuestion]);






  // Helper function to insert text at cursor position
  const insertAtCursor = (textToInsert) => {
    const textarea = document.getElementById('Answer');
    if (!textarea) return;

    const startPos = textarea.selectionStart;
    const endPos = textarea.selectionEnd;

    const before = answer.substring(0, startPos);
    const after = answer.substring(endPos);

    const newValue = before + textToInsert + after;
    setAnswer(newValue);

    // Set focus back to textarea and place cursor after inserted text
    setTimeout(() => {
      textarea.focus();
      const newPosition = startPos + textToInsert.length;
      textarea.setSelectionRange(newPosition, newPosition);
    }, 0);
  };




  // Function to apply formatting
  const applyFormat = (format) => {
    const textarea = document.getElementById('Answer');
    if (!textarea) return;

    // Save the current scroll position
    const scrollPos = textarea.scrollTop;

    const startPos = textarea.selectionStart;
    const endPos = textarea.selectionEnd;

    if (startPos === endPos) {
      // No text selected, just insert the formatting tags
      let formatTags = '';
      switch (format) {
        case 'bold': formatTags = '****'; break;
        case 'italic': formatTags = '__'; break;
        case 'underline': formatTags = '<u></u>'; break;
        case 'strikethrough': formatTags = '~~~~'; break;
        case 'monospace': formatTags = '``'; break;
        default: return;
      }

      const newValue = answer.substring(0, startPos) + formatTags + answer.substring(endPos);
      setAnswer(newValue);

      // Position cursor between tags
      setTimeout(() => {
        textarea.focus();
        const midPoint = startPos + formatTags.length / 2;
        textarea.setSelectionRange(midPoint, midPoint);

        // Restore scroll position
        textarea.scrollTop = scrollPos;
      }, 0);
    } else {
      // Text is selected, wrap it with formatting tags
      const selectedText = answer.substring(startPos, endPos);
      let before = answer.substring(0, startPos);
      let after = answer.substring(endPos);
      let newValue = '';
      let tagLength = 0;

      switch (format) {
        case 'bold':
          newValue = before + '*' + selectedText + '*' + after;
          tagLength = 4; // ** before and ** after
          break;
        case 'italic':
          newValue = before + '_' + selectedText + '_' + after;
          tagLength = 2; // _ before and _ after
          break;
        case 'strikethrough':
          newValue = before + '~' + selectedText + '~' + after;
          tagLength = 4; // ~~ before and ~~ after
          break;
        case 'monospace':
          newValue = before + '```' + selectedText + '```' + after;
          tagLength = 6; // ``` before and ``` after
          break;
        default:
          return;
      }

      setAnswer(newValue);

      // Set selection to include the formatted text
      const newPos = endPos + tagLength;
      setTimeout(() => {
        textarea.focus();
        textarea.setSelectionRange(startPos, newPos);

        // Restore scroll position
        textarea.scrollTop = scrollPos;
      }, 0);
    }
  };

  // Function to insert emoji
  const insertEmoji = (emoji) => {
    const textarea = document.getElementById('Answer');
    if (!textarea) return;

    // Save the current scroll position
    const scrollPos = textarea.scrollTop;

    insertAtCursor(emoji);

    // After inserting the emoji, restore the scroll position
    setTimeout(() => {
      textarea.focus();
      textarea.scrollTop = scrollPos;
    }, 0);
  };

  // Enhanced emoji categories with more options
  const emojiCategories = {
    "Smileys & Emotions": ["😀", "😃", "😄", "😁", "😆", "😅", "🤣", "😂", "🙂", "😊", "😇", "🥰", "😍", "🤩", "😘", "😗", "☺️", "😚", "😙", "🥲", "😏", "😌", "😔", "😑", "🤔", "🤫", "🤭"],
    "Gestures & People": ["👍", "👎", "👌", "🤌", "🤏", "✌️", "🤞", "🫰", "🤟", "🤘", "🤙", "👈", "👉", "👆", "👇", "☝️", "👋", "🫶", "🙏", "👏"],
    "Nature & Animals": ["🐶", "🐱", "🐭", "🦊", "🐻", "🐼", "🐨", "🐯", "🦁", "🐮", "🐷", "🐸", "🐵", "🐔", "🦄", "🦋", "🐢", "🐬", "🦉", "🦅", "🌸", "🌹", "🌺", "🌻", "🌼", "🌷"],
    "Food & Drink": ["🍎", "🍐", "🍊", "🍋", "🍌", "🍉", "🍇", "🍓", "🫐", "🍈", "🍒", "🍑", "🥭", "🍍", "🥥", "🥝", "🍅", "🍆", "🥑", "🌮", "🍕", "🍔", "🍟", "🍱", "🍜", "☕", "🧋", "🍷"],
    "Activities & Objects": ["⚽", "🏀", "🏈", "⚾", "🎾", "🏐", "🎱", "🏓", "⛳", "🎮", "🧩", "🎭", "🎨", "🎬", "📚", "💻", "📱", "💡", "📝", "🔑", "🎁", "🎈", "🎉", "🎊", "🏆", "🥇", "🎵", "🎸"],
    "Symbols & Currency": ["❤️", "🧡", "💛", "💚", "💙", "💜", "🖤", "🤍", "🤎", "💔", "❣️", "💯", "⭐", "🌟", "✨", "⚡", "🔥", "💥", "☀️", "🌈", "$", "€", "£", "¥", "₹", "₽", "M", "₿", "¢", "₩"]
  };

  // Define these functions outside any conditional blocks
  const handleButtonClick = () => {
    setIsActive(true);
    if (inputCount === 0) {
      setInputCount(1);
    }
  };

  const handleAddClick = () => {
    if (inputCount < 3) {
      setInputCount(inputCount + 1);
    }
  };

  const handleRemoveClick = (indexToRemove) => {
    if (inputCount > 1) {
      setInputCount(inputCount - 1);
    }
  };


  const handleAnsFromChange = (e) => {
  const value = e.target.value;
  setansFrom(value);

  // Optional: validate and clear error
  if (value === '---Select---' || !value) {
    setErrors(prev => ({ ...prev, ansFrom: 'Please select an answer source.' }));
  } else {
    setErrors(prev => ({ ...prev, ansFrom: '' }));
  }
};



  // Unique function names to avoid conflicts with existing code
  // const handleButtonUrlClick = () => {
  //   setIsButtonUrlActive(true);
  // };

  const handleButtonUrlAddClick = () => {
    if (buttonUrlInputCount < 3) {
      setButtonUrlInputCount(buttonUrlInputCount + 1);
    }
  };

  const handleButtonUrlRemoveClick = (indexToRemove) => {
    // Remove the specific input pair and reindex the remaining values
    const updatedValues = { ...buttonUrlInputValues };

    // Shift all values after the removed index
    for (let i = indexToRemove; i < buttonUrlInputCount - 1; i++) {
      updatedValues[`text_${i}`] = updatedValues[`text_${i + 1}`];
      updatedValues[`url_${i}`] = updatedValues[`url_${i + 1}`];
    }

    // Remove the last pair
    delete updatedValues[`text_${buttonUrlInputCount - 1}`];
    delete updatedValues[`url_${buttonUrlInputCount - 1}`];

    setButtonUrlInputValues(updatedValues);
    setButtonUrlInputCount(buttonUrlInputCount - 1);
  };

  const handleButtonUrlInputChange = (index, value, fieldType) => {
    setButtonUrlInputValues({
      ...buttonUrlInputValues,
      [`${fieldType}_${index}`]: value
    });

  };




  return (
    <>




      <section id="Chatbot">
        <div className="container">
          <div className="Chatbot_header">
            <div className="Bot_id scrollable">
              <h5>
                Sequence: <span>{root}</span>
              </h5>
            </div>
          </div>
          <div className="row">
            <div className="col-lg-4">
              <div className="Chatbot_leftBar">
                <ul className="ul_lists">
                  <li>
                    <div className="Bot_group">
                      <label htmlFor="stage">Question Title</label>
                      <select
                        name="stage"
                        id="stage"
                        value={selectedOption}
                        onChange={(e) => setSelectedOption(e.target.value)}
                      >
                        {options.length === 0 ? (
                          <option>Welcome</option>
                        ) : (
                          <>
                            <option>---Select---</option>
                            {options.map((option, index) => (
                              <option key={index} value={option.question_id}>
                                {option.ques_title}
                              </option>
                            ))}
                          </>
                        )}
                      </select>
                    </div>
                  </li>
                  <li>
                    <div className="Bot_group">
                      <label htmlFor="Question">Enter Question Title</label>
                      <input
                        type="text"
                        name="Question"
                        id="Question"
                        value={title}
                        onChange={(e) => setTitle(e.target.value)}
                        placeholder="Enter Your Question Title"
                      />
                      {errors.question && <span className="error">{errors.question}</span>}
                    </div>
                  </li>
                  <li>
                    <div className="Bot_group">
                      <label htmlFor="Question">Question</label>
                      <input
                        type="text"
                        name="Question"
                        id="Question"
                        value={question}
                        onChange={(e) => setQuestion(e.target.value)}
                        placeholder="Enter Your Question Here"
                      />
                      {errors.question && <span className="error">{errors.question}</span>}
                    </div>
                  </li>
                  <li>
                    <div className="Bot_group">
                      <label htmlFor="Qtype">Question Type</label>
                      <select
                        name="Qtype"
                        id="Qtype"
                        value={qType}
                        onChange={(e) => setQType(e.target.value)}
                      >
                        <option value="TEXT">Text</option>
                        <option value="DOCUMENT">Document</option>
                        <option value="IMAGE">Image</option>
                        <option value="LOCATION">Location</option>
                        <option value="BUTTON">Button</option>
                        <option value="button_url">Button URL</option>

                        {/* <option value="media">Media</option> */}
                      </select>
                    </div>
                  </li>


                  <li>
                    <div className="Bot_group">
                      <label htmlFor="AnsFrom">Answer From</label>
                      <select
                        name="AnsFrom"
                        id="AnsFrom"
                        value={ansFrom}
                        onChange={handleAnsFromChange}
                       
                      >
                        <option>---Select---</option>
                        <option value="Internal">Internal</option>
                        <option value="External">External</option>
                      </select>
                      {errors.ansFrom && <span className="error">{errors.ansFrom}</span>}
                    </div>
                  </li>
                  {fileOptions && (
                    <li>
                      <div className="Bot_group">
                        <label htmlFor="Answer">File</label>
                        <input
                          type="file"
                          name="Answer"
                          id="Answer"
                          onChange={handleUserFilechange} />
                      </div>
                    </li>
                  )}
                  <li>




{ansFrom === 'Internal' && (

                    <div className="Bot_group">
                  

                      <label htmlFor="Answer">Answer    <div className="formatting-toolbar" style={{
                        marginBottom: '8px',
                        display: 'flex',
                        flexWrap: 'wrap',
                        gap: '5px'
                      }}>
                        <button
                          type="button"
                          onClick={() => applyFormat('bold')}
                          style={{
                            padding: '4px 8px',
                            fontWeight: 'bold',
                            border: '1px solid #ccc',
                            borderRadius: '4px',
                            background: '#f0f0f0',
                            cursor: 'pointer'
                          }}
                          title="Bold"
                        >
                          B
                        </button>
                        <button
                          type="button"
                          onClick={() => applyFormat('italic')}
                          style={{
                            padding: '4px 8px',
                            fontStyle: 'italic',
                            border: '1px solid #ccc',
                            borderRadius: '4px',
                            background: '#f0f0f0',
                            cursor: 'pointer'
                          }}
                          title="Italic"
                        >
                          I
                        </button>

                        <button
                          type="button"
                          onClick={() => applyFormat('strikethrough')}
                          style={{
                            padding: '4px 8px',
                            textDecoration: 'line-through',
                            border: '1px solid #ccc',
                            borderRadius: '4px',
                            background: '#f0f0f0',
                            cursor: 'pointer'
                          }}
                          title="Strikethrough"
                        >
                          S
                        </button>
                        <button
                          type="button"
                          onClick={() => applyFormat('monospace')}
                          style={{
                            padding: '4px 8px',
                            fontFamily: 'monospace',
                            border: '1px solid #ccc',
                            borderRadius: '4px',
                            background: '#f0f0f0',
                            cursor: 'pointer'
                          }}
                          title="Monospace"
                        >
                          M
                        </button>
                        <button
                          type="button"
                          onClick={() => setShowEmojiPicker(!showEmojiPicker)}
                          style={{
                            padding: '4px 8px',
                            border: '1px solid #ccc',
                            borderRadius: '4px',
                            background: '#f0f0f0',
                            cursor: 'pointer'
                          }}
                          title="Emoji"
                        >
                          😊
                        </button>
                      </div>

                        {/* Enhanced Emoji picker */}
                        {showEmojiPicker && (
                          <div style={{
                            border: '1px solid #ccc',
                            borderRadius: '4px',
                            padding: '10px',
                            marginBottom: '10px',
                            backgroundColor: '#f9f9f9',
                            maxHeight: '250px',
                            overflowY: 'auto',
                            boxShadow: '0 2px 5px rgba(0,0,0,0.1)'
                          }}>
                            <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '10px' }}>
                              <span style={{ fontWeight: 'bold' }}>Emoji Picker</span>
                              <button
                                type="button"
                                onClick={() => setShowEmojiPicker(false)}
                                style={{ border: 'none', background: 'none', cursor: 'pointer', fontSize: '16px' }}
                              >
                                ✖️
                              </button>
                            </div>

                            {Object.entries(emojiCategories).map(([category, emojis]) => (
                              <div key={category} style={{ marginBottom: '12px' }}>
                                <div style={{
                                  fontWeight: 'bold',
                                  fontSize: '13px',
                                  color: '#555',
                                  marginBottom: '5px',
                                  borderBottom: '1px solid #eee',
                                  paddingBottom: '3px'
                                }}>
                                  {category}
                                </div>
                                <div style={{
                                  display: 'flex',
                                  flexWrap: 'wrap',
                                  gap: '4px'
                                }}>
                                  {emojis.map((emoji, index) => (
                                    <button
                                      key={index}
                                      type="button"
                                      onClick={() => insertEmoji(emoji)}
                                      style={{
                                        width: '32px',
                                        height: '32px',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        cursor: 'pointer',
                                        border: '1px solid #e0e0e0',
                                        borderRadius: '4px',
                                        backgroundColor: '#fff',
                                        fontSize: '18px',
                                        transition: 'transform 0.1s',
                                        ':hover': {
                                          transform: 'scale(1.1)',
                                          backgroundColor: '#f0f0f0'
                                        }
                                      }}
                                      onMouseOver={(e) => {
                                        e.currentTarget.style.transform = 'scale(1.1)';
                                        e.currentTarget.style.backgroundColor = '#f0f0f0';
                                      }}
                                      onMouseOut={(e) => {
                                        e.currentTarget.style.transform = 'scale(1)';
                                        e.currentTarget.style.backgroundColor = '#fff';
                                      }}
                                    >
                                      {emoji}
                                    </button>
                                  ))}
                                </div>
                              </div>
                            ))}
                          </div>
                        )}</label>

                      <textarea
                        name="Answer"
                        id="Answer"
                        value={answer}
                        onChange={(e) => setAnswer(e.target.value)}
                        placeholder="Enter Your Answer Here"
                      ></textarea>
                      {errors.answer && <span className="error">{errors.answer}</span>}
                    </div>

                      )
                      }


                      {ansFrom === 'External' && (
  <div className="Bot_group">
    <label htmlFor="externalLink">Answer (External Link)</label>
    <input
      type="url"
      id="externalLink"
      name="externalLink"
      value={answer}
      onChange={(e) => setAnswer(e.target.value)}
      placeholder="https://example.com"
      style={{
        width: '100%',
        padding: '10px',
        border: '1px solid #ccc',
        borderRadius: '4px'
      }}
    />
    {errors.answer && <span className="error">{errors.answer}</span>}
  </div>
)}

                  </li>

                  <div>
                    {/* Your existing content here */}

                    {qType === 'BUTTON' && (
                      <div className="button-type-container">
                   
                          <div>
                            {[...Array(inputCount)].map((_, index) => (
                              <div key={index} className="input-container animate-fadeIn">
                                <div className="input_max_char">

                                  <input
                                    type="text"
                                    className="input-field"
                                    placeholder={`Enter Button Text `}
                                    maxLength={20}
                                    value={inputValues[index] || ''}
                                    onChange={(e) => handleInputChange(index, e.target.value)}
                                    required
                                  />
                                  <span>{(inputValues[index]?.length || 0)}/20</span>
                                </div>
                                {index > 0 && (
                                  // <button
                                  //   onClick={() => handleRemoveClick(index)}
                                  //   className="remove-button"
                                  // >
                                  //   Remove
                                  // </button>
                                  <img src={DeleteIcon} onClick={() => handleRemoveClick(index)} className="remove-button" alt="remove icon" />
                                )}
                              </div>
                            ))}

                            {inputCount < 3 && (
                              <button
                                onClick={handleAddClick}
                                className="add-button"
                              >
                                <span>Add</span>
                                <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
                                  <path fillRule="evenodd" d="M10 5a1 1 0 011 1v3h3a1 1 0 110 2h-3v3a1 1 0 11-2 0v-3H6a1 1 0 110-2h3V6a1 1 0 011-1z" clipRule="evenodd" />
                                </svg>
                              </button>
                            )}

                            {/* Display error message if inputs are not valid */}
                            {errors && errors.dynamicInputs && (
                              <div className="error-message" style={{ color: 'red', marginTop: '8px' }}>
                                {errors.dynamicInputs}
                              </div>
                            )}
                          </div>
                       
                      </div>
                    )}






                    {qType === 'button_url' && (
                      <div className="button-type-container">
                     
                          <div>
                            {[...Array(buttonUrlInputCount)].map((_, index) => (
                              <div key={index} className="input-container button_text_group animate-fadeIn">
                                <div className="input_group_fields_new">
                                  <div className="input_max_char">
                                    <input
                                      type="text"
                                      className="input-field"
                                      placeholder={` Enter Button Text `}
                                      maxLength={20}
                                      value={buttonUrlInputValues[`text_${index}`] || ''}
                                      onChange={(e) => handleButtonUrlInputChange(index, e.target.value, 'text')}
                                      required
                                    />
                                    <span>{(buttonUrlInputValues[`text_${index}`]?.length || 0)}/20</span>
                                  </div>
                                  <div className="input_max_char">
                                    <input
                                      type="text"
                                      className="input-field"
                                      placeholder={`https://yourdomainname.com`}
                                      maxLength={500}
                                      value={buttonUrlInputValues[`url_${index}`] || ''}
                                      onChange={(e) => handleButtonUrlInputChange(index, e.target.value, 'url')}
                                      required
                                    />
                                     <span>{(buttonUrlInputValues[`url_${index}`]?.length || 0)}/500</span>
                                  </div>
                                </div>
                                <div className="delet_btn_group">
                                  {index > 0 && (
                                    // <button
                                    //   onClick={() => handleButtonUrlRemoveClick(index)}
                                    //   className="remove-button"
                                    // >
                                    //   Remove
                                    // </button>
                                    <img src={DeleteIcon} onClick={() => handleButtonUrlRemoveClick(index)} className="remove-button" alt="remove icon" />
                                  )}
                                </div>
                              </div>
                            ))}

                            {/* {buttonUrlInputCount < 3 && (
                              <button
                                onClick={handleButtonUrlAddClick}
                                className="add-button"
                              >
                                <span>Add</span>
                                <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
                                  <path fillRule="evenodd" d="M10 5a1 1 0 011 1v3h3a1 1 0 110 2h-3v3a1 1 0 11-2 0v-3H6a1 1 0 110-2h3V6a1 1 0 011-1z" clipRule="evenodd" />
                                </svg>
                              </button>
                            )} */}

                            {errors && errors.buttonUrlInputs && (
                              <div className="error-message" style={{ color: 'red', marginTop: '8px' }}>
                                {errors.buttonUrlInputs}
                              </div>
                            )}
                          </div>
                        
                      </div>
                    )}
                  </div>

                  <li className="userinput_li_group userinput_li_group_list">
                    <div className="Bot_group UserInput_box">
                      <label htmlFor="userinput">UserInput</label>
                      <input
                        type="checkbox"
                        checked={userCheckBox}  // Bind checkbox state
                        onChange={handleCheckBoxChange} // Track change
                      />
                    </div>
                  </li>

                  {userCheckBox && (  // Conditionally enable user input field
                    <li>
                      <div className="Bot_group">
                        <textarea
                          name="userinput"
                          id="userinput"
                          value={userInputAns}
                          onChange={(e) => setUserInputAns(e.target.value)}
                          placeholder="Enter Your Answer Here"
                        ></textarea>
                        {errors.answer && <span className="error">{errors.answer}</span>}
                      </div>
                    </li>
                  )}


                  <li>
                    <button type="button" className="Bot_saveBtn" onClick={handleSave}>
                      Save
                    </button>
                  </li>
                </ul>
              </div>
            </div>
            <div className="col-lg-8">
              <div className="Chatboat_rightBar">
                <div className="d-flex justify-content-between px-2">
                  <div>Bot ID: <span>{getBotId}</span></div>
                  <div>Date: <span>{getcreateDate}</span></div>
                </div>
                <div className="BotTable_contain">
                  <table className="Bot_table">
                    <thead>
                      <tr>
                        <th>Ques_Name</th>
                        <th>Ques_Type</th>
                        <th>Media</th>
                        <th className="Answer_th">Answer</th>
                        <th>Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {tableData && tableData.length > 0 ? (

                        tableData.map((row) => {
                          // Check if media_url is null
                          if (!row.media_url) {
                            return (
                              <tr key={row.id}>
                                <td>{row.question}</td>
                                <td>{row.msg_type}</td>
                                <td></td> {/* Empty column if media_url is null */}
                                <td>{row.answer}</td>
                                <td>
                                  <div className="d-flex ">
                                    <button onClick={() => handleDeleteRow(row.id)} className="ChatBotDeleteBtn mx-3">
                                      <img src={deleteIcon} alt="Delete" />
                                    </button>

                                    <button onClick={() => handleEditClick(row.id)} className="ChatBotUpdateBtn">
                                      <img src={EditIcon} alt="Update" />
                                    </button>
                                  </div>
                                </td>
                              </tr>
                            );
                          }





                          // Extract file extension from the media_url
                          const fileExtension = row.media_url.split('.').pop().toLowerCase();

                          // Function to determine if the media is an image
                          const isImage = (ext) => ['jpg', 'jpeg', 'png', 'gif'].includes(ext);

                          // Function to determine if the media is an audio
                          const isAudio = (ext) => ['mp3', 'wav', 'ogg'].includes(ext);

                          // Function to determine if the media is a video
                          const isVideo = (ext) => ['mp4', 'avi', 'mov', 'mkv'].includes(ext);

                          return (
                            <tr key={row.id}>
                              <td>{row.question}</td>
                              <td>{row.msg_type}</td>
                              <td>
                                <a href={`${row.media_url}`} target="_blank" rel="noopener noreferrer">
                                  {isImage(fileExtension) ? (
                                    <img
                                      src={ImageIcon}
                                      alt="Image Media"
                                      style={{ width: '25px', height: '25px' }}
                                      loading="lazy"
                                    />
                                  ) : isAudio(fileExtension) ? (
                                    <img
                                      src={AudioIcon}  // Replace with an actual audio icon path
                                      alt="Audio File"
                                      style={{ width: '25px', height: '25px' }}
                                      loading="lazy"
                                    />
                                  ) : isVideo(fileExtension) ? (
                                    <img
                                      src={VideoIcon}  // Replace with an actual video icon path
                                      alt="Video File"
                                      style={{ width: '25px', height: '25px' }}
                                      loading="lazy"
                                    />
                                  ) : (
                                    <img
                                      src={DocIcon}  // Default icon for documents like PDFs
                                      alt="Doc Icon"
                                      style={{ width: '25px', height: '25px' }}
                                      loading="lazy"
                                    />
                                  )}
                                </a>
                              </td>
                              <td>{row.answer}</td>
                              <td>
                                <button onClick={() => handleDeleteRow(row.id)}>
                                  <img src={deleteIcon} alt="Delete" />
                                </button>
                              </td>
                            </tr>
                          );
                        })
                      ) : (
                        <tr>
                          <td colSpan="5">No data available</td>
                        </tr>
                      )}
                    </tbody>


                  </table>
                </div>
              </div>
            </div>
          </div>

          {editModalOpen && selectedQuestion && (
            <div className="custom-edit-modal-overlay">
              <div className="custom-edit-modal">
                <h3>Edit Answer</h3>
                <p><strong>Ques Name:</strong> {selectedQuestion.question}</p>
                <p><strong>Ques Type:</strong> {selectedQuestion.msg_type}</p>
                <p><strong>Media:</strong> {selectedQuestion.Media || ""}</p>
                <div>
                  <label>Answer:</label>
                  <textarea
                    value={newAnswer !== "" ? newAnswer : selectedQuestion.answer}
                    onChange={(e) => setNewAnswer(e.target.value)}
                  />
                </div>
                <button onClick={handleUpdateAnswer}>Update</button>
                <button onClick={() => setEditModalOpen(false)}>Cancel</button>
              </div>
            </div>
          )}

        </div>
      </section>
      {loading && (
        <div className="spinnerOverlay">
          <ClipLoader loading={loading} size={50} />
        </div>
      )}
    </>
  );
};

export default Chatboat;
